var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "jn2nu8lrxa",
    d: "M0 0.5L56.129 0.5 56.129 57 0 57z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-153 -119) translate(153 119) translate(0 .5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ocpwhpzlvb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jn2nu8lrxa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#7896D2",
    d: "M0 28.561C0 35.287 5.453 40.74 12.18 40.74h31.077c7.11 0 12.873-5.763 12.873-12.873h-.035C55.72 12.692 43.328.5 28.064.5 12.801.5.41 12.692.035 27.866H0v.695z",
    mask: "url(#ocpwhpzlvb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD63E",
    d: "M49.636 27.635c0 11.914-9.657 21.572-21.57 21.572-11.915 0-21.574-9.658-21.574-21.572H34.7c1.332 0 3.092-6.515 4.049-6.515 1.295 0 2.477 6.515 3.61 6.515h7.277z",
    transform: "translate(-153 -119) translate(153 119)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M20.415 41.24c1.328 2.9 4.25 4.92 7.65 4.92 3.4 0 6.32-2.02 7.65-4.92h-15.3z",
    transform: "translate(-153 -119) translate(153 119)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3CAF7",
    d: "M0 29.065C0 13.565 12.564 1 28.064 1S56.13 13.565 56.13 29.065H43.254c-1.809 0-3.259-7.945-4.35-7.945-1.892 0-3.568 7.945-5.03 7.945H0z",
    transform: "translate(-153 -119) translate(153 119)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profileIcon.8f0a81ec9cb83d05d0d2351edc230581.svg";
export { ForwardRef as ReactComponent };